import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {runAfterLoadSession} from "../../utils/Utility";
import {listMyFavorite, removeMyFavorite} from "../../utils/API";
import HeaderApp from "../home/HeaderApp";
import {NavLink} from "react-router-dom";
import QuestionModal from "../utils/QuestionModal";

class FavoriteList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            favorites: [],
            showRemoveFav: false,
            apiRemoveFav: false,
            currentFav: undefined,

        }
    }

    componentDidMount() {
        runAfterLoadSession(() => {
            listMyFavorite((res) => {
                this.setState({favorites: res})
            })
        })

    }

    removeFavorite = () => {
        removeMyFavorite(this.state.currentFav.hashId, (res) => {
            this.setState({
                favorites: res,
                showRemoveFav: false,
                apiRemoveFav: false,
                currentFav: undefined,
            })
        }, () => {
            this.setState({
                showRemoveFav: false,
                apiRemoveFav: false,
                currentFav: undefined,
            })
        })
    }

    render() {
        return (
            <div className="">
                <HeaderApp name="Favorites" back="/hom"/>
                <div className="main-app">
                    <div>
                        <div className="mt-3 body-app">
                            <div>
                                    {this.state.favorites.length === 0 &&
                                <span className="d-block text-center mb-4">You have not added any favorite tutors yet.</span>}
                                {
                                    this.state.favorites.map((c) =>
                                        <div key={c.hashId} className="shadow-black mb-3 p-3">
                                            <div className="d-flex flex-row">
                                                <div className="d-flex">
                                                    <img className="img-circle"
                                                         src={window.baseFile + c.profilePhotoUrl} alt=""/>
                                                </div>
                                                <div className="d-flex flex-row justify-content-between w-100">
                                                    <div
                                                        className="d-flex flex-column align-items-start justify-content-around ml-2">
                                                        <div><span>{c.username}</span></div>
                                                        <div><span
                                                            className="bold">Rating: {c.avgScore.toFixed(1)}/5</span>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <div><span
                                                            className={c.online ? "green-status" : "red-status"}>{c.online ? "online" : "offline"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-4">
                                                <NavLink
                                                    className="waves-effect waves-light btn white mr-3 no-uppercase  shadow-black"
                                                    to={"/hom/new-task/" + c.hashId}>
                                                    <span className="black-text">New Request</span>
                                                </NavLink>
                                                <button
                                                    onClick={() => this.setState({
                                                        showRemoveFav: true,
                                                        currentFav: c,
                                                    })}
                                                    className="waves-effect waves-light btn red  no-uppercase bold shadow-black">
                                                    <span>Remove</span>
                                                </button>
                                            </div>
                                        </div>)
                                }
                            </div>
                        </div>

                    </div>

                    <QuestionModal show={this.state.showRemoveFav}
                                   onHide={() => this.setState({showRemoveFav: false})}
                                   acceptTitle="Yes"
                                   rejectTitle="No"
                                   onReject={() => this.setState({showRemoveFav: false})}
                                   hideButton={this.state.apiRemoveFav}
                                   onAccept={this.removeFavorite}
                    >
                        <div className="text-center p-3">
                            <span>{'Are you sure about removing the favorite tutor?'}</span>
                        </div>
                    </QuestionModal>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
        tutorEnv: state.param[Objects.tutorEnv],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteList)
